// extracted by mini-css-extract-plugin
module.exports = {"mCurated":"Pg","flipped":"Qg","mainContentContainer":"Rg","cta":"Sg","mainContentCtaDefault":"Tg","disabled":"Ug","mainContentCtaWhite":"Vg"};